import { ArrowUpRight, CalendarCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { SITE } from "@/constants/site";
import { Reveal } from "@/components/Reveal";
import { useLang } from "@/i18n/LangContext";

export const CTABlock = ({ title, text, dark = true, withLogo = false, ctaLabel }) => {
  const { t, l } = useLang();
  const d = t.common.cta;
  const finalTitle = title || d.title;
  const finalText = text || d.text;
  const finalCtaLabel = ctaLabel || d.ctaLabel;

  const renderText = (txt) =>
    txt.split(/([\w.+-]+@[\w-]+\.[\w.]+)/g).map((part, i) =>
      /^[\w.+-]+@[\w-]+\.[\w.]+$/.test(part) ? (
        <a key={i} href={`mailto:${part}`} className="underline decoration-terracotta/60 underline-offset-4 hover:decoration-terracotta">
          {part}
        </a>
      ) : (
        part
      )
    );
  return (
  <section className="px-5 md:px-10 pb-24 md:pb-32" data-testid="cta-block">
    <Reveal className="max-w-6xl mx-auto">
      <div
        className={`relative overflow-hidden rounded-[2.5rem] px-8 py-16 md:px-16 md:py-24 grain ${
          dark ? "bg-ink text-cream" : "bg-terracotta-light/50 text-ink"
        }`}
      >
        <div
          className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-terracotta/25 blur-3xl"
          aria-hidden="true"
        />
        <div
          className="absolute -bottom-40 -left-24 w-80 h-80 rounded-full bg-terracotta/15 blur-3xl"
          aria-hidden="true"
        />
        <div className="relative max-w-2xl">
          {withLogo && (
            <img
              src="/assets/logo-consultante-strategie-de-marque-pme.png"
              alt={t.logoAlt}
              className="mb-8 h-20 w-20 rounded-2xl object-cover shadow-[0_16px_40px_-12px_rgba(0,0,0,0.4)]"
            />
          )}
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-balance">{finalTitle}</h2>
          <p className={`mt-6 text-base md:text-lg leading-relaxed ${dark ? "text-cream/70" : "text-plum/80"}`}>
            {renderText(finalText)}
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href={SITE.calendly}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-calendly-button"
              className="group inline-flex items-center gap-2.5 rounded-full bg-terracotta px-7 py-4 text-sm font-semibold text-ink transition-colors duration-300 hover:bg-terracotta-dark"
            >
              <CalendarCheck className="w-4.5 h-4.5 w-5 h-5" strokeWidth={2} />
              {finalCtaLabel}
              <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <Link
              to={l("/contact")}
              data-testid="cta-email-button"
              className={`inline-flex items-center gap-2 rounded-full border px-7 py-4 text-sm font-semibold transition-colors duration-300 ${
                dark
                  ? "border-cream/25 text-cream hover:bg-cream/10"
                  : "border-ink/20 text-ink hover:bg-ink/5"
              }`}
            >
              {t.common.requestQuote}
            </Link>
          </div>
        </div>
      </div>
    </Reveal>
  </section>
  );
};
